import { action } from 'typesafe-actions';

import { ChangeKnoInMeasureActionsEnum } from '../enums/ChangeKnoInMeasureActionsEnum';
import { IKnoOrganisationChild } from '../../APIPackage/CatalogsModule/interfaces/IKnoOrganisationChild';
import { IMeasureKnoChangeHistoryItem } from '../../APIPackage/KnmModule/interfaces/IMeasureKnoChangeHistoryItem';
import { IMeasureNumberSearchItem } from '../../APIPackage/KnmModule/interfaces/IMeasureNumberSearchItem';
import { KnmVersionsEnum } from '../../APIPackage/KnmModule/enums/KnmVersionsEnum';

export const getErvkOrganisations = () => action(ChangeKnoInMeasureActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_GET);

export const setErvkOrganisationsSearchQuery = (searchQuery: string) =>
  action(ChangeKnoInMeasureActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_SET_SEARCH_QUERY, { searchQuery });

export const setErvkOrganisations = (knoOrganisations: IKnoOrganisationChild[]) =>
  action(ChangeKnoInMeasureActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_SET, { knoOrganisations });

export const getMeasureNumbers = () => action(ChangeKnoInMeasureActionsEnum.CHANGE_KNO_MEASURE_NUMBERS_GET);

export const setMeasureNumbersSearchQuery = (searchQuery: string) =>
  action(ChangeKnoInMeasureActionsEnum.CHANGE_KNO_MEASURE_NUMBERS_SET_SEARCH_QUERY, { searchQuery });

export const setMeasureNumbers = (measureNumbers: IMeasureNumberSearchItem[]) =>
  action(ChangeKnoInMeasureActionsEnum.CHANGE_KNO_MEASURE_NUMBERS_SET, { measureNumbers });

export const startProcessFormSubmit = (
  erpId: string,
  changeReason: string,
  ervkKnoOrganization: IKnoOrganisationChild,
  system: KnmVersionsEnum,
) => action(ChangeKnoInMeasureActionsEnum.CHANGE_KNO_FORM_SUBMIT, { erpId, changeReason, ervkKnoOrganization, system });

export const changeKnoGetMeasureHistoryChanges = () =>
  action(ChangeKnoInMeasureActionsEnum.CHANGE_KNO_MEASURE_HISTORY_CHANGES_GET);

export const changeKnoSetMeasureHistoryChanges = (historyItems: IMeasureKnoChangeHistoryItem[]) =>
  action(ChangeKnoInMeasureActionsEnum.CHANGE_KNO_MEASURE_HISTORY_CHANGES_SET, { historyItems });
